import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Box } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";

import { appActions } from "@ip-store/actions";

function Alerts({ alerted, appActions, items }) {
  items = items.filter((alert) => !alerted.includes(alert.id));

  const renderContent = (str) => {
    return str.replace(
      "<a ",
      '<a style="color:#0000EE; text-decoration:underline" '
    );
  };

  return (
    !!items.length && (
      <Box marginBottom={3}>
        {items.map((alert, key) => (
          <Alert
            key={key}
            severity={alert.severity}
            onClose={() => appActions.storeAlerted(alert.id)}
          >
            {alert.title && <AlertTitle>{alert.title}</AlertTitle>}
            <div
              dangerouslySetInnerHTML={{ __html: renderContent(alert.content) }}
            />
          </Alert>
        ))}
      </Box>
    )
  );
}

const mapStateToProps = (state) => ({
  alerted: state.app.alerted,
});

const mapDispatchToProps = (dispatch) => ({
  appActions: bindActionCreators(appActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
